import styles from './reload_prompt.module.css';

import {useRegisterSW} from 'virtual:pwa-register/react';
import {pwaInfo} from 'virtual:pwa-info';

console.log(pwaInfo);

export function ReloadPrompt() {
    // replaced dynamically
    const buildDate = '__DATE__';
    // replaced dyanmicaly
    const reloadSW = '__RELOAD_SW__';

    const {
        offlineReady: [offlineReady, setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisteredSW(swUrl, r) {
            console.log(`Service Worker at: ${swUrl}`);
            // @ts-expect-error just ignore
            if (reloadSW === 'true') {
                r &&
                    setInterval(() => {
                        console.log('Checking for sw update');
                        r.update();
                    }, 20000 /* 20s for testing purposes */);
            } else {
                // eslint-disable-next-line prefer-template
                console.log('SW Registered: ' + r);
            }
        },
        onRegisterError(error) {
            console.log('SW registration error', error);
        },
    });

    const close = () => {
        setOfflineReady(false);
        setNeedRefresh(false);
    };

    return (
        <div className={styles.container}>
            {(offlineReady || needRefresh) && (
                <div className={styles.toast}>
                    <div className={styles.message}>
                        {offlineReady ? (
                            <span>App ready to work offline</span>
                        ) : (
                            <span>New content available, click on reload button to update.</span>
                        )}
                    </div>
                    {needRefresh && (
                        <button className={styles['toast-button']} onClick={() => updateServiceWorker(true)}>
                            Reload
                        </button>
                    )}
                    <button className={styles['toast-button']} onClick={() => close()}>
                        Close
                    </button>
                </div>
            )}
            <div className={styles.date}>{buildDate}</div>
        </div>
    );
}
